<template>
  <v-card class="pa-4 text-center card-pad">
    <v-btn absolute top right icon small @click="$emit('close')" text>
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <h3 class="mb-4">
      <strong
        >{{ isEditing ? $t('Atualizar') : $t('Adicionar') }} template</strong
      >
    </h3>

    <v-form ref="form">
      <v-row class="ma-0" dense>
        <v-col cols="12" sm="6" class="text-start">
          <label class="text-caption">{{ $t('Nome do template') }}</label>
          <v-text-field
            v-model="template.name"
            :placeholder="$t('Nome do template')"
            class="primary-input"
            outlined
            dense
            hide-details="auto"
            :rules="[(v) => !!v || 'Nome do template é obrigatório']"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-text-field>
        </v-col>

        <v-col cols="12" sm="3" class="text-start">
          <label class="text-caption">Tipo</label>
          <v-autocomplete
            :items="types"
            item-text="text"
            item-value="value"
            append-icon="mdi-chevron-down"
            v-model="template.type"
            placeholder="Tipo de template"
            class="primary-input"
            outlined
            dense
            hide-details="auto"
            :rules="[(v) => v != null || 'Tipo do template é obrigatório']"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="3" class="text-start" v-if="template.type == 1">
          <label class="text-caption">{{
            $t('Sem vínculo de equipamento')
          }}</label>
          <v-switch
            v-model="template.withoutEquipment"
            inset
            color="#BBCF20"
          ></v-switch>
        </v-col>

        <v-col cols="12" sm="6" class="text-start" v-if="template.type == 0">
          <label class="text-caption">{{ $t('Equipamento padrão') }}</label>
          <v-autocomplete
            :items="standardEquipments"
            item-text="name"
            :loading="standardEquipmentLoading"
            item-value="id"
            append-icon="mdi-chevron-down"
            v-model="template.standardEquipmentId"
            class="primary-input"
            :placeholder="$t('Equipamento padrão do template')"
            outlined
            dense
            hide-details="auto"
            :rules="[(v) => !!v || 'Equipamento padrão é obrigatório']"
          >
            <template #message="{ message }">
              {{ $t(message) }}
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" class="text-start" v-if="template.type == 1">
          <label class="text-caption">Setor</label>
          <v-autocomplete
            :items="departments"
            item-text="name"
            :loading="departmentLoading"
            item-value="id"
            append-icon="mdi-chevron-down"
            v-model="departmentIds"
            multiple
            class="primary-input"
            outlined
            dense
            placeholder="Setor do template"
            hide-details="auto"
            :rules="[(v) => !!v || 'Setor é obrigatório']"
          >
            <template v-slot:item="{ item }">
              <span class="text-caption" v-if="item.unidade">
                {{ item.name }} / {{ item.unidade.name }}
              </span>
              <span class="text-caption" v-else>
                {{ item.name }}
              </span>
            </template>
          </v-autocomplete>
        </v-col>

        <span style="z-index: -1">{{ selectedEquipments.length == true }}</span>

        <v-col
          class="text-start"
          cols="12"
          v-if="selectedEquipments.length > 0"
        >
          <strong class="ml-4">Equipamentos</strong>
          <v-virtual-scroll
            class="mt-4"
            :items="selectedEquipments"
            height="200"
            item-height="64"
          >
            <template v-slot:default="{ item }">
              <v-card
                elevation="0"
                color="#f5f5f5"
                rounded="lg"
                class="d-flex align-center justify-space-between text-start py-2 px-6"
                :key="item.id"
              >
                <div>
                  <strong> {{ item.identification }}</strong>
                  <span> - {{ item.name }} </span>
                </div>

                <v-btn text icon color="error" @click="remove(item)">
                  <v-icon small> mdi-trash-can-outline </v-icon>
                </v-btn>
              </v-card>
            </template>
          </v-virtual-scroll>
        </v-col>

        <v-col cols="12" class="text-start">
          <label class="text-caption">Itens</label>
          <v-autocomplete
            :items="items"
            item-text="name"
            :loading="itemsLoading"
            item-value="id"
            placeholder="Itens do template"
            multiple
            clearable
            append-icon="mdi-chevron-down"
            chips
            v-model="selectedItems"
            class="primary-input"
            outlined
            dense
            hide-details="auto"
            :rules="[(v) => (!!v && v.length > 0) || 'Itens é obrigatório']"
          >
            <template v-slot:item="{ item, attrs, on }">
              <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-action>
                  <v-checkbox :input-value="attrs.inputValue" color="primary" />
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.name }}
                    <span class="grey--text text--darken-1"> / {{ item.inspectionRoutineChecklistItemClass ? item.inspectionRoutineChecklistItemClass.name : 'Não informado' }}</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-form>

    <InspectionRoutineOrdenation
      v-if="isEditing && ordenationModal"
      v-model="ordenationModal"
      :template="template"
      :items="template.items || []"
      @save="template.items = $event"
    />

    <div class="d-flex">
      <v-btn
        v-if="isEditing"
        class="secondary-button mr-2"
        depressed
        @click="ordenationModal = true"
      >
        Ordenar Itens
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        class="primary-button mr-0"
        depressed
        @click="submit"
        :loading="loading"
      >
        {{ isEditing ? 'Atualizar' : 'Adicionar' }}
      </v-btn>
    </div>
  </v-card>
</template>

<style scoped lang="scss">
.table-custom {
  &::v-deep .v-data-table__wrapper {
    thead {
      border: none !important;

      th {
        border: none !important;
        &:first-child {
          border-radius: 4px 0 0 4px;
        }

        &:last-child {
          border-radius: 0 4px 4px 0;
        }
      }
    }
  }
}
</style>

<script>
import ApiService from '../../../../../services/ApiService'
import GeneralService from '../../../../../services/GeneralService'
import Utils from '../../../../../Utils/FormatDate'
import InspectionRoutineOrdenation from './InspectionRoutineOrdenation'

export default {
  name: 'ManageItemModal',

  components: {
    InspectionRoutineOrdenation,
  },

  props: {
    templateId: {
      type: Number,
      default: () => {},
    },
  },

  async created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    this.getStandardEquipments()
    this.getDepartments()
    this.getItems()
    await this.getEquipments()
    if (this.templateId) {
      this.isEditing = true
      this.getTemplate()
    }

    this.template.institutionId = this.institutionId
  },

  data() {
    return {
      departmentIds: [],
      selectedEquipments: [],
      selectedItems: [],
      headers: [
        {
          text: '',
          align: 'start',
          value: '',
        },
        {
          text: 'Item',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Criado em',
          align: 'start',
          sortable: false,
          value: 'createdAt',
        },
      ],
      filters: false,
      items: [],
      itemsLoading: false,
      generalService: new GeneralService(),
      apiService: new ApiService(),
      template: {},
      isEditing: false,
      loading: false,
      ordenationModal: false,
      institutionId: '',
      equipments: [],
      standardEquipments: [],
      standardEquipmentLoading: false,
      equipmentLoading: false,
      departmentLoading: false,
      departments: [],
      types: [
        { text: 'Equipamento', value: 0 },
        { text: 'Setor', value: 1 },
      ],
    }
  },

  methods: {
    remove(item) {
      const index = this.selectedEquipments.indexOf(item)
      if (index >= 0) this.selectedEquipments.splice(index, 1)
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    getTemplate() {
      this.loading = true
      this.apiService
        .get(`inspectionRoutineChecklistTemplate/${this.templateId}`)
        .then((response) => {
          this.template = response.content

          const ids = this.template.equipments.map((x) => x.equipmentId)
          // this.selectedEquipments = this.template.equipments.map(
          //   (x) => x.equipmentId
          // );

          this.selectedEquipments = this.equipments.filter((x) =>
            ids.includes(x.id)
          )

          this.departmentIds = this.template.departments.map(
            (x) => x.departmentId
          )

          this.selectedItems = this.template.items.map((x) => x.itemId)
          this.loading = false
        })
        .catch((er) => {
          this.loading = false
        })
    },

    getItems() {
      this.itemsLoading = true

      this.apiService
        .get(`inspectionRoutineChecklistItem/list/${this.institutionId}`)
        .then((response) => {
          this.items = response.content
          this.itemsLoading = false
        })
        .catch(() => {
          this.itemsLoading = false
        })
    },

    async getDepartments() {
      this.departmentLoading = true
      await this.apiService
        .get(`department/listActive/${this.institutionId}`)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    async getStandardEquipments() {
      try {
        this.standardEquipmentLoading = true

        this.standardEquipments =
          await this.generalService.getStandardEquipmentsByInstitution(
            this.institutionId
          )

        this.standardEquipmentLoading = false
      } catch (error) {
        this.standardEquipmentLoading = false
      }
    },

    async getEquipments() {
      this.equipmentLoading = true

      await this.apiService
        .get(`equipment/list/${this.institutionId}`)
        .then((response) => {
          this.equipments = response.content
          this.equipmentLoading = false
        })
        .catch(() => {
          this.equipmentLoading = false
        })
    },

    submit() {
      if (this.$refs.form.validate()) {
        // this.loading = true;
        let url = 'inspectionRoutineChecklistTemplate/add'

        if (this.isEditing) {
          url = 'inspectionRoutineChecklistTemplate/edit'
        }

        this.template.departments = this.departmentIds.map((x) => {
          return {
            departmentId: x,
          }
        })

        // Preserve id/order of items that already existed so the ordering
        // saved via "Salvar Ordem" is not lost when the template is saved.
        const existingItemsByItemId = {}
        ;(this.template.items || []).forEach((it) => {
          existingItemsByItemId[it.itemId] = it
        })

        this.template.items = this.selectedItems.map((x) => {
          const existing = existingItemsByItemId[x]
          return {
            id: existing ? existing.id : 0,
            templateId: this.template.id,
            itemId: x,
            order: existing ? existing.order : null,
          }
        })

        this.template.equipments = this.selectedEquipments.map((x) => {
          return {
            templateId: this.template.id,
            equipmentId: x.id,
          }
        })

        this.apiService
          .post(url, this.template)
          .then(() => {
            this.$emit('confirm')
            this.$toast.success(
              `Template ${
                this.isEditing ? 'atualizado' : 'adicionado'
              } com sucesso!`
            )
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
  },

  watch: {
    'filter.page': {
      deep: true,
      handler() {
        this.getItems()
      },
    },
  },
}
</script>
